const setCanvasPreview = (
  image, // HTMLImageElement
  canvas, // HTMLCanvasElement
  crop // PixelCrop
) => {
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("No 2d context");
  }

  // Standard size for the cropped image
  const standardSize = 500;

  // devicePixelRatio for retina display compatibility
  const pixelRatio = window.devicePixelRatio;
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;

  // Set the canvas size
  canvas.width = standardSize * pixelRatio;
  canvas.height = standardSize * pixelRatio;

  ctx.scale(pixelRatio, pixelRatio);
  ctx.imageSmoothingQuality = "high";

  const cropX = crop.x * scaleX;
  const cropY = crop.y * scaleY;
  const cropWidth = crop.width * scaleX;
  const cropHeight = crop.height * scaleY;

  // Apply a circular mask if the final image should be circular
  ctx.beginPath();
  ctx.arc(standardSize / 2, standardSize / 2, standardSize / 2, 0, 2 * Math.PI);
  ctx.clip();

  // Draw the cropped image to the canvas
  ctx.drawImage(
    image,
    cropX,
    cropY,
    cropWidth,
    cropHeight,
    0,
    0,
    standardSize,
    standardSize
  );

  ctx.restore();
};
export default setCanvasPreview;
